import React from 'react';
import {Toolbar} from 'react-onsenui';
import classNames from 'classnames';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import isBrowser from "../../utils/isBrowser";
import * as actions from '../../actions';

function ChatHeader({ title, mode, clickDebuggerButton, clickFullButton, clickCloseButton}) {

  const chatHeaderLeftButtonClass = classNames(
    'button-group',
    {
      'hide': mode != "development"
    }
  );

  const chatHeaderRightButtonClass = classNames(
    'button-group',
    {
      'hide': !isBrowser()
    }
  );

  return (
    <Toolbar className={'cu-ui-chat-header'}>
      <div className='left'>
        <div className={chatHeaderLeftButtonClass}>
          <button className={'cu-ui-button cu-ui-outline'} onClick={() => {clickDebuggerButton()}}>
            <div className={'mdi mdi-android-debug-bridge'}></div>
          </button>
        </div>
      </div>
      <div className='center'>
        <div className={'cu-ui-title'}>
          {title}
        </div>
      </div>
      <div className='right'>
        <div className={chatHeaderRightButtonClass}>
          <button className={'cu-ui-button cu-ui-outline'} onClick={() => {clickFullButton()}}>
            <div className={'mdi mdi-arrow-expand'}></div>
          </button>
          <button className={'cu-ui-button cu-ui-outline'} onClick={() => {clickCloseButton()}}>
            <div className={'mdi mdi-window-close'}></div>
          </button>
        </div>
      </div>
    </Toolbar>
  )
};


const mapStateToProps = (state, props) => ({
});

const mapDispatchToProps = (dispatch) => {
  return {
    clickDebuggerButton: bindActionCreators(actions.clickDebuggerButton, dispatch),
    clickFullButton: bindActionCreators(actions.clickFullButton, dispatch),
    clickCloseButton: bindActionCreators(actions.clickCloseButton, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChatHeader);



// WEBPACK FOOTER //
// ./src/components/chat-header/index.jsx